<div id="videoContainer">
<mat-icon class="close-icon" (click)="onConfirmClick()">close</mat-icon>
<video  controls  [src]="data.URL"  width="600" >
</video>
</div>